<app-header></app-header>
<div class="container">
	<div class="app-content">
					<div class="side-app">
						<div class="page-header">
							
							<h4 class="page-title pt-3 pb-3">Privacy Policy</h4>
							<!-- <div class="update_status"><span>Last updated on  12 / 2/2019</span></div>
							<ol class="breadcrumb">
								<li class="breadcrumb-item"><a href="#">CMS</a></li>
								<li class="breadcrumb-item active" aria-current="page">Privacy Policy</li>
							</ol> -->
						</div>
						<div class="row ">
							<div class="col-md-12 mt-5">
								<div class="card">
									<div class="card-body">
										<!-- <h4><b>Heading1</b></h4> -->
										<p><span class="colorch">Sanch Motors Pvt Ltd</span> & Website: www.okshan.com believes in the best expectations of trustworthiness corresponding to information provided by its customers at the time of interaction with the Company, and otherwise.</p>
										<p>OKSHAN values your privacy and commits to protect information disclosed by the users (“You”)
											to OKSHAN either by means of the OKSHAN website/mobile application. Please read the
											following policy (hereinafter referred to as “Privacy Policy”) to understand practices of
											OKSHAN, and specifically with regards, as to how OKSHAN treats information disclosed by You.
											By using the domain and sub-domains of www.okshan.com including its mobile applications,
											You agree that, You have acceded to the terms of the present Privacy Policy. In the event that
											You do not wish to be bound by these terms, You have a choice, which is free from any form of
											coercion or undue influence, to not access the OKSHAN Website. This Privacy Policy also applies
											generally to our parent, affiliates, subsidiaries, or joint venture websites.</p>
											<p>The term “We”/ “Us” / “Our” used in this document refer to OKSHAN and &quot;You&quot; / &quot;Your&quot;
												/&quot;Yourself&quot; refer to the users, who visit or access or use (collectively“usage”) Platform.</p>
											<p>We request You to carefully read this Privacy Policy and Terms of Use under the different tab
												before sharing personal information with us. By browsing, visiting, accessing and/or using the
												services on OKSHAN Website (or searching for any of the pages on OKSHAN Website), You
												explicitly consent and agree to our Privacy Policy laid out herein. You also agree that the
												information furnished by You is lawful, true and correct and does not violate or infringe any
												laws. No liability pertaining to the authenticity/ genuineness/ misrepresentation/ fraud/
												negligence, etc. of the information disclosed shall lie on the Company/OKSHAN nor will the
												Company/OKSHAN in any way be responsible to verify any information obtained from You.</p>
											<p>By using OKSHAN, You consent to the collection, storage, and use of your browsing history on
												this website. We share this information with trusted Third parties that use it to show your
												marketing communications of interest. While no Personally Identifiable Information is shared,
												we respect your right to privacy and hence provide this transparent disclosure.</p>
										</div>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>INFORMATION WE COLLECT</b></h4>
										<h5><b>The following type of information about You may be collected and processed by the Company:</b></h5>
										<h5><b>a. Information provided directly to us</b></h5>
										<ul>
											<li>Account / User Information – including but not limited to your name, address, email address, mobile / telephone number, gender, income, and any other
												information sought by OKSHAN at the time of your making an account with
												OKSHAN, or obtaining a quote from OKSHAN</li>
											<li>Payment Information - Billing, Shipping, Payment cards information shared when
												you make a purchase</li>
											<li>Vehicle Information -Details in respect of your vehicle, including but not limited
												to make, model, identification details of the vehicle, prior use, history, insurance
												details, registration certificate details, etc.</li>
										  </ul> 
										</div>
										<div class="card-body">
											<h5><b>b. Non-Personal Information</b></h5>
											<ul>
												<li>Information about your internet connection and mobile device</li>
												<li>The equipment used by You to browse the OKSHAN Website</li>
												<li>Your usage details in respect of the OKSHAN Website</li>
												<li>Internet Protocol (IP) details/ address</li>
												<li>Your Current Location, Device Location, Device Information, Communication
													Information to provide customized offerings.</li>
												<li>Computer operating system</li>
												<li>Your searches, the results You selected from the search and other activities</li>
												<li>Your browsing information (browsing length, details of online ads that You
													clicked on)</li>
													<li>Your transactional information</li>
														<li>We use online tracking tools like Google Analytics, Google Webmaster, browser
															cookies and web beacons for collecting certain information about your usage of
															the Site.</li>
											  </ul> 
											<p>Please note that the above list is only illustrative, and is by no means, exhaustive.</p>
											</div>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>HOW YOUR INFORMATION IS USED</b></h4>
										<p>We use information to contact you.We might use the information you provide us to contact you
											for confirmation of a test drive request/sell request on our website or for other promotional
											purposes.</p>
											<p>We use information to respond to your requests or questions.​We might use your information to
												answer your queries concerning our products or services.</p>

												<p>We use information to improve our products and services.​We might use your information to
													customize your experience on our website. This may include displaying certain content based
													on your preferences and/or our website usage.</p>

													<p>We use information to look at site trends and customer interests.​We may use your information
to make our website and products better. We may combine information we get from you with
information about you we get from third parties.</p>
														<p>We use information for marketing purposes.​ From time to time, we might send you information
															about special promotions or offers. We might also inform you about new features or products.
															These might be our own offers or products, or third-party offers or products we think you might
															find interesting. Or, for example, if you sign up on our website and/or blog we may enroll you in
															our newsletter.</p>
															<p>We use information to send you transactional communications.​ We might send you emails or
																SMS about your account, any test drives you may request/undertake, any car purchase you may
																make or any car you may request to sell.</p>
																<p>We use information as otherwise permitted by law, or to comply with the law or orders of law
																	enforcement agencies or to enforce our legal rights.</p>
										</div>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>SHARING OF INFORMATION WITH THIRD-PARTIES</b></h4>
										<p>We will share information with third parties who perform services on our behalf.​ We may share
											information with vendors who help us manage our online registration process or payment
											processors or transactional message processors.</p>

											<p>We may share information if we think we have to in order to comply with the law or to protect
												ourselves.​ We will share information to respond to a court order or judicial summons. We may
												also share it if a government agency or investigatory body requests. Or, we might also share
												information when we are investigating potential fraud.</p>

												<p>We may share information with any successor to all or part of our business.​ For example, if part
													of our business is sold we may give our customer list as part of that transaction.</p>	
													
													<p>We may share your information for reasons not described in this policy.​ We will tell you before
														we do this.</p>
												</div>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>THIRD PARTY INTEGRATION</b></h4>
										<p>You may access Okshan Website through third-party websites over which Okshan has no
											control. You may optionally provide Okshan with information through third-party sign-in
											services such as Facebook, Pinterest, Twitter, Instagram, and Google Plus. In such cases, Okshan
											fetches and stores whatever information is made available to Okshan by You through these
											sign-in services. Please also note that Okshan reserves its rights to use information provided by
											You, in consonance with all relevant laws and guidelines.</p>	
											
											<p>Further, it is clarified that while Your usage of Okshan Website, You might see the links to the
												third party website / advertisements / electronic communication service, which are provided by
												the third parties. As the operation of the third party is not under control of the Company,
												therefore the Company does not make any endorsement / guarantee of any service or product
												offered through third party websites nor make any representation related to the any privacy
												policy or other policies of such third party. Any usage of such third-party website or availing any
												service or product through third party shall be at Your risk and the Company is not responsible
												for any loss / damage or otherwise. It is recommended that You should review the privacy
												policy of such third-party websites prior to using such websites.</p>										</div>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>DISCLOSURE TO THIRD PARTY SERVICE PROVIDERS</b></h4>
										<p>Okshan shall be at liberty to disclose your information or part thereof to third party service
											providers who may facilitate the providing of services, on our behalf. These service providers
											have access to your data only to perform the tasks as stipulated by Okshan and are obligated
											not to disclose or use it for any other purpose. Okshan may also share personal information
											with third-party vendors, consultants, and other service providers who work for the Company,
											who are bound by contractual obligations to keep personal information confidential and use it
											only for the purposes for which the Company disclose it to them..</p>	
											
											<p>In addition to the aforesaid, alliance partners/channel partners of Okshan may collect
												information with your consent from your mobile device like device location, device information
												(including storage, model, installed apps, Wi-Fi, mobile network) transactional and promotional
												SMS, communication information including contacts to provide customized offerings.</p>										</div>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>THIRD PARTY SITE USAGE</b></h4>
										<p>If you click on one of the links to third party websites, you may be taken to websites we do not
											control. This policy does not apply to the privacy practices of those websites. Read the privacy
											policy of other websites carefully. We are not responsible for these third-party sites.</p>	
									</div>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>AMENDMENT</b></h4>
										<p>The Company reserves the right to amend or modify this Privacy Policy at any time, as and
											when the need arises. We request you to regularly check this Privacy Policy from time to time
											to keep you updated about changes made. Your continued use of the services provided by
											OKSHAN after any changes, shall be deemed to be your acceptance of such changes</p>	
									</div>
								</div>
							</div>

							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>AMENDMENT</b></h4>
										<p>In the event You have any complaints or concerns with respect to the Okshan Website or our
											services or if You have any questions about this Privacy Policy, please feel free to contact us
											on +91-804413429  (between 9:30 AM - 6:30 PM) on working days or reach out to our
											customer support at info@okshan.com</p>	
									</div>
								</div>
							</div>

							<div class="col-md-12">
								<div class="card">
									<div class="card-body">
										<h4><b>GRIEVANCE REDRESSAL</b></h4>
										<p>In compliance with Information Technology Act, 2000 and the rules made thereunder, You may
											write us at below mentioned Email Address:</p>	
											<p>Email Address: grievance@okshan.com</p>	
											<p>(Please include the following subject line in the email – “Attention: Grievance Officer”)</p>	
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
				</div>
<app-footer></app-footer>
